const ger_base_x = 4;

export default [
  // {
  // 	id: 1,
  // 	x: 0,
  // 	y: 0+0.7,
  // }, 
  // {
  // 	id: 1,
  // 	x: 30,
  // 	y: 50+0.7,
  // },

  // ITALIA
  // Italia 1775-1779
  {
    id: 7,
    x: 19.8 - 0.1,
    y: 10 + 0.7,
  }, {
    id: 48,
    x: 20.1 - 0.1,
    y: 10.5 + 0.7,
  }, {
    id: 97,
    x: 20.2 - 0.1,
    y: 12 + 0.7,
  }, {
    id: 98,
    x: 20.3 - 0.1,
    y: 13 + 0.7,
  }, {
    id: 167,
    x: 20.4 - 0.1,
    y: 14 + 0.7,
  }, {
    id: 129,
    x: 20.5 - 0.1,
    y: 15 + 0.7,
  }, {
    id: 125,
    x: 20.5 - 0.1,
    y: 16 + 0.7,
  }, {
    id: 4,
    x: 20.5 - 0.1,
    y: 17 + 0.7,
  }, {
    id: 95,
    x: 20.5 - 0.1,
    y: 18 + 0.7,

  }, {
    id: 130,
    x: 20.5 - 0.1,
    y: 19 + 0.7,
  }, {
    id: 190,
    x: 20.5 - 0.1,
    y: 20 + 0.7,
  }, {
    id: 191,
    x: 20.5 - 0.1,
    y: 21 + 0.7,
  }, {
    id: 72,
    x: 20.5 - 0.1,
    y: 22 + 0.7,
  }, {
    id: 168,
    x: 20.5 - 0.1,
    y: 23 + 0.7,
  }, {
    id: 175,
    x: 20.5 - 0.1,
    y: 24 + 0.7,
  }, {
    id: 192,
    x: 20.4 - 0.1,
    y: 25 + 0.7,
  }, {
    id: 198,
    x: 20.3 - 0.1,
    y: 26 + 0.7,
  }, {
    id: 26,
    x: 20.2 - 0.1,
    y: 27 + 0.7,
  }, {
    id: 108,
    x: 20.1 - 0.1,
    y: 27.5 + 0.7,
  }, {
    id: 122,
    x: 19.8 - 0.1,
    y: 29 + 0.7,
  },
  // Italia 1780-1784
  {
    id: 27,
    x: 20.8,
    y: 10 + 0.7,
  }, {
    id: 50,
    x: 21.1,
    y: 11 + 0.7,
  }, {
    id: 124,
    x: 21.2,
    y: 12 + 0.7,
  }, {
    id: 169,
    x: 21.3,
    y: 13 + 0.7,
  }, {
    id: 193,
    x: 21.4,
    y: 14 + 0.7,
  }, {
    id: 8,
    x: 21.5,
    y: 15 + 0.7,
  }, {
    id: 142,
    x: 21.5,
    y: 16 + 0.7,
  }, {
    id: 143,
    x: 21.5,
    y: 17 + 0.7,
  }, {
    id: 12,
    x: 21.5,
    y: 18 + 0.7,

  }, {
    id: 61,
    x: 21.5,
    y: 19 + 0.7,
  }, {
    id: 88,
    x: 21.5,
    y: 20 + 0.7,
  }, {
    id: 141,
    x: 21.5,
    y: 21 + 0.7,
  }, {
    id: 139,
    x: 21.5,
    y: 22 + 0.7,
  }, {
    id: 10,
    x: 21.5,
    y: 23 + 0.7,
  }, {
    id: 13,
    x: 21.5,
    y: 24 + 0.7,
  }, {
    id: 16,
    x: 21.4,
    y: 25 + 0.7,
  }, {
    id: 144,
    x: 21.3,
    y: 26 + 0.7,
  }, {
    id: 145,
    x: 21.2,
    y: 27 + 0.7,
  }, {
    id: 182,
    x: 21.1,
    y: 28 + 0.7,
  },
  {
    id: 197,
    x: 20.8,
    y: 29 + 0.7,
  },
  // Italia 1785-1789
  {
    id: 9,
    x: 22.4 + 0.1,
    y: 14.5 + 0.3,
  }, {
    id: 15,
    x: 22.5 + 0.1,
    y: 15.5 + 0.3,
  }, {
    id: 100,
    x: 22.5 + 0.1,
    y: 16.5 + 0.3,
  }, {
    id: 196,
    x: 22.5 + 0.1,
    y: 17.5 + 0.3,
  }, {
    id: 14,
    x: 22.5 + 0.1,
    y: 18.5 + 0.3,
  }, {
    id: 49,
    x: 22.5 + 0.1,
    y: 19.5 + 0.3,
  }, {
    id: 101,
    x: 22.5 + 0.1,
    y: 20.5 + 0.3,
  }, {
    id: 215,
    x: 22.5 + 0.1,
    y: 21.5 + 0.3,
  }, {
    id: 216,
    x: 22.5 + 0.1,
    y: 22.5 + 0.3,
  },
  {
    id: 219,
    x: 22.5,
    y: 23.5 + 0.3,
  }, {
    id: 28,
    x: 22.4 + 0.1,
    y: 24.5 + 0.3,
  }, {
    id: 217,
    x: 22.3 + 0.1,
    y: 25.5 + 0.3,
  },
  // Italia 1790-1794
  {
    id: 218,
    x: 21.4 + 2.1,
    y: 14 + 0.3,
  }, {
    id: 59,
    x: 21.5 + 2.1,
    y: 15 + 0.3,
  }, {
    id: 173,
    x: 21.5 + 2.1,
    y: 16 + 0.3,
  }, {
    id: 62,
    x: 21.5 + 2.1,
    y: 17 + 0.3,
  }, {
    id: 68,
    x: 21.5 + 2.1,
    y: 18 + 0.3,

  }, {
    id: 115,
    x: 21.5 + 2.1,
    y: 19 + 0.3,
  }, {
    id: 47,
    x: 21.5 + 2.1,
    y: 20 + 0.3,
  }, {
    id: 63,
    x: 21.5 + 2.1,
    y: 21 + 0.3,
  }, {
    id: 67,
    x: 21.5 + 2.1,
    y: 22 + 0.3,
  }, {
    id: 82,
    x: 21.5 + 2.1,
    y: 23 + 0.3,
  }, {
    id: 113,
    x: 21.5 + 2.1,
    y: 24 + 0.3,
  }, {
    id: 120,
    x: 21.4 + 2.1,
    y: 25 + 0.3,
  }, {
    id: 200,
    x: 21.3 + 2.1,
    y: 26 + 0.3,
  },
  // Italia 1795-1799
  {
    id: 11,
    x: 21.4 + 3.1,
    y: 14 + 0.3,
  }, {
    id: 178,
    x: 21.5 + 3.1,
    y: 15 + 0.3,
  }, {
    id: 60,
    x: 21.5 + 3.1,
    y: 16 + 0.3,
  }, {
    id: 64,
    x: 21.5 + 3.1,
    y: 17 + 0.3,
  }, {
    id: 77,
    x: 21.5 + 3.1,
    y: 18 + 0.3,

  }, {
    id: 199,
    x: 21.5 + 3.1,
    y: 19 + 0.3,
  }, {
    id: 78,
    x: 21.5 + 3.1,
    y: 20 + 0.3,
  }, {
    id: 80,
    x: 21.5 + 3.1,
    y: 21 + 0.3,
  }, {
    id: 206,
    x: 21.5 + 3.1,
    y: 22 + 0.3,
  }, {
    id: 5,
    x: 21.5 + 3.1,
    y: 23 + 0.3,
  }, {
    id: 29,
    x: 21.5 + 3.1,
    y: 24 + 0.3,
  }, {
    id: 81,
    x: 21.4 + 3.1,
    y: 25 + 0.3,
  }, {
    id: 1,
    x: 21.3 + 3.1,
    y: 26 + 0.3,
  },
  // Italia 1800-1804
  {
    id: 83,
    x: 22.5 + 3.1,
    y: 17.5 + 0.3,
  }, {
    id: 180,
    x: 22.5 + 3.1,
    y: 18.5 + 0.3,
  }, {
    id: 76,
    x: 22.5 + 3.1,
    y: 19.5 + 0.3,
  }, {
    id: 32,
    x: 22.5 + 3.1,
    y: 20.5 + 0.3,
  }, {
    id: 74,
    x: 22.5 + 3.1,
    y: 21.5 + 0.3,
  }, {
    id: 65,
    x: 22.5 + 3.1,
    y: 22.5 + 0.3,
  },
  // Italia 1805-1809
  {
    id: 33,
    x: 22.4 + 4.2,
    y: 16.5 + 0.3,
  }, {
    id: 70,
    x: 22.5 + 4.2,
    y: 17.5 + 0.3,
  }, {
    id: 127,
    x: 22.5 + 4.2,
    y: 18.5 + 0.3,
  }, {
    id: 174,
    x: 22.5 + 4.2,
    y: 19.5 + 0.3,
  }, {
    id: 128,
    x: 22.5 + 4.2,
    y: 20.5 + 0.3,
  }, {
    id: 84,
    x: 22.5 + 4.2,
    y: 21.5 + 0.3,
  }, {
    id: 71,
    x: 22.5 + 4.2,
    y: 22.5 + 0.3,
  }, {
    id: 163,
    x: 22.4 + 4.2,
    y: 23.5 + 0.3,
  },
  // Italia 1810-1814
  {
    id: 204,
    x: 22.4 + 5.3,
    y: 20 + 0.3,
  },
  // Italia 1815-1819
  {
    id: 31,
    x: 22.4 + 6.4,
    y: 19.5 + 0.3,
  }, {
    id: 69,
    x: 22.4 + 6.4,
    y: 20.5 + 0.3,
  },
  // Italia 1820-1824
  {
    id: 202,
    x: 22.4 + 7.5,
    y: 19.5 + 0.3,
  }, {
    id: 93,
    x: 22.4 + 7.5,
    y: 20.5 + 0.3,
  },
  // GERMANY
  // Germany 1775-1779
  {
    id: 107,
    x: ger_base_x,
    y: 18 - 1 + 0.7,
  }, {
    id: 133,
    x: ger_base_x,
    y: 19 - 1 + 0.7,
  }, {
    id: 150,
    x: ger_base_x,
    y: 20 - 1 + 0.7,
  }, {
    id: 147,
    x: ger_base_x,
    y: 21 - 1 + 0.7,
  }, {
    id: 149,
    x: ger_base_x,
    y: 22 - 1 + 0.7,
  },
  //Germany 1780-1784
  {
    id: 103,
    x: ger_base_x + 1.1,
    y: 18 + 0.7,
  }, {
    id: 104,
    x: ger_base_x + 1.1,
    y: 19 + 0.7,
  }, {
    id: 171,
    x: ger_base_x + 1.1,
    y: 20 + 0.7,
  }, {
    id: 165,
    x: ger_base_x + 1.1,
    y: 21 + 0.7,
  }, {
    id: 131,
    x: ger_base_x + 1.1,
    y: 22 + 0.7,
  },
  {
    id: 148,
    x: ger_base_x + 1.1,
    y: 17 + 0.7,
  },
  //Germany 1785-1789
  {
    id: 126,
    x: ger_base_x + 2.2,
    y: 22 + 0.5 + 0.7,
  }, {
    id: 170,
    x: ger_base_x + 2.2,
    y: 23 + 0.5 + 0.7,
  }, {
    id: 79,
    x: ger_base_x + 2.2,
    y: 24 + 0.5 + 0.7,
  }, {
    id: 19,
    x: ger_base_x + 2.2,
    y: 14 + 0.5 + 0.7,
  }, {
    id: 138,
    x: ger_base_x + 2.2,
    y: 15 + 0.5 + 0.7,
  },
  {
    id: 208,
    x: ger_base_x + 2.2,
    y: 16 + 0.5 + 0.7,
  }, {
    id: 211,
    x: ger_base_x + 2.2,
    y: 17 + 0.5 + 0.7,
  }, {
    id: 136,
    x: ger_base_x + 2.2,
    y: 18 + 0.5 + 0.7,
  }, {
    id: 137,
    x: ger_base_x + 2.2,
    y: 19 + 0.5 + 0.7,
  }, {
    id: 17,
    x: ger_base_x + 2.2,
    y: 20 + 0.5 + 0.7,
  },
  {
    id: 57,
    x: ger_base_x + 2.2,
    y: 21 + 0.5 + 0.7,
  },
  //Germany 1790-1794
  {
    id: 154,
    x: ger_base_x + 3.3,
    y: 11.5 + 0.7,
  }, {
    id: 189,
    x: ger_base_x + 3.3,
    y: 12.5 + 0.7,
  }, {
    id: 207,
    x: ger_base_x + 3.3,
    y: 13.5 + 0.7,
  }, {
    id: 35,
    x: ger_base_x + 3.3,
    y: 14.5 + 0.7,
  }, {
    id: 44,
    x: ger_base_x + 3.3,
    y: 15.5 + 0.7,
  }, {
    id: 87,
    x: ger_base_x + 3.3,
    y: 16.5 + 0.7,
  }, {
    id: 102,
    x: ger_base_x + 3.3,
    y: 17.5 + 0.7,
  }, {
    id: 56,
    x: ger_base_x + 3.3,
    y: 18.5 + 0.7,
  }, {
    id: 110,
    x: ger_base_x + 3.3,
    y: 19.5 + 0.7,
  }, {
    id: 86,
    x: ger_base_x + 3.3,
    y: 20.5 + 0.7,
  }, {
    id: 135,
    x: ger_base_x + 3.3,
    y: 21.5 + 0.7,
  }, {
    id: 152,
    x: ger_base_x + 3.3,
    y: 22.5 + 0.7,
  }, {
    id: 153,
    x: ger_base_x + 3.3,
    y: 23.5 + 0.7,
  }, {
    id: 156,
    x: ger_base_x + 3.3,
    y: 24.5 + 0.7,
  }, {
    id: 184,
    x: ger_base_x + 3.3,
    y: 25.5 + 0.7,
  }, {
    id: 123,
    x: ger_base_x + 3.3,
    y: 26.5 + 0.7,
  }, {
    id: 21,
    x: ger_base_x + 3.3,
    y: 27.5 + 0.7,
  },
  //Germany 1795-1799 
  {
    id: 155,
    x: ger_base_x + 4.4,
    y: 15.5 + 0.7,
  }, {
    id: 176,
    x: ger_base_x + 4.4,
    y: 16.5 + 0.7,
  }, {
    id: 213,
    x: ger_base_x + 4.4,
    y: 17.5 + 0.7,
  }, {
    id: 112,
    x: ger_base_x + 4.4,
    y: 18.5 + 0.7,
  }, {
    id: 116,
    x: ger_base_x + 4.4,
    y: 19.5 + 0.7,
  }, {
    id: 37,
    x: ger_base_x + 4.4,
    y: 20.5 + 0.7,
  }, {
    id: 158,
    x: ger_base_x + 4.4,
    y: 21.5 + 0.7,
  }, {
    id: 161,
    x: ger_base_x + 4.4,
    y: 22.5 + 0.7,
  }, {
    id: 181,
    x: ger_base_x + 4.4,
    y: 23.5 + 0.7,
  },
  //Germany 1800-1804
  {
    id: 18,
    x: ger_base_x + 5.5,
    y: 19.5 - 0.4 + 0.7,
  }, {
    id: 75,
    x: ger_base_x + 5.5,
    y: 20.5 - 0.4 + 0.7,
  },
  //Germany 1805-1809
  {
    id: 46,
    x: ger_base_x + 6.6,
    y: 19.5 - 0.4 + 0.7,
  }, {
    id: 2,
    x: ger_base_x + 6.6,
    y: 20.5 - 0.4 + 0.7,
  },
  //Germany 1810-1814
  {
    id: 73,
    x: ger_base_x + 7.7,
    y: 18.5 + 0.7,
  }, {
    id: 162,
    x: ger_base_x + 7.7,
    y: 19.5 + 0.7,
  }, {
    id: 53,
    x: ger_base_x + 7.7,
    y: 20.5 + 0.7,
  },
  //Germany 1815-1819
  {
    id: 185,
    x: ger_base_x + 8.8,
    y: 18.5 + 0.7,
  }, {
    id: 3,
    x: ger_base_x + 8.8,
    y: 19.5 + 0.7,
  }, {
    id: 205,
    x: ger_base_x + 8.8,
    y: 20.5 + 0.7,
  },
  //Germany 1820-1824
  {
    id: 54,
    x: ger_base_x + 9.9,
    y: 19.5 + 0.7,
  },
  //Germany 1825-1829
  {
    id: 159,
    x: ger_base_x + 11,
    y: 22.5 + 0.7,
  }, {
    id: 201,
    x: ger_base_x + 11,
    y: 16.5 + 0.7,
  }, {
    id: 209,
    x: ger_base_x + 11,
    y: 17.5 + 0.7,
  },
  {
    id: 45,
    x: ger_base_x + 11,
    y: 18.5 + 0.7,
  }, {
    id: 186,
    x: ger_base_x + 11,
    y: 19.5 + 0.7,
  }, {
    id: 187,
    x: ger_base_x + 11,
    y: 20.5 + 0.7,
  },
  {
    id: 210,
    x: ger_base_x + 11,
    y: 21.5 + 0.7,
  },
  //Germany 1830-1834
  {
    id: 36,
    x: ger_base_x + 12.1,
    y: 15.5 + 1 + 0.7,
  }, {
    id: 203,
    x: ger_base_x + 12.1,
    y: 16.5 + 1 + 0.7,
  }, {
    id: 111,
    x: ger_base_x + 12.1,
    y: 17.5 + 1 + 0.7,
  },
  {
    id: 160,
    x: ger_base_x + 12.1,
    y: 18.5 + 1 + 0.7,
  }, {
    id: 55,
    x: ger_base_x + 12.1,
    y: 19.5 + 1 + 0.7,
  }, {
    id: 94,
    x: ger_base_x + 12.1,
    y: 20.5 + 1 + 0.7,
  },
  {
    id: 92,
    x: ger_base_x + 12.1,
    y: 21.5 + 1 + 0.7,
  },
  // Austria
  // Austria 1775-1779
  {
    id: 119,
    x: 16.8,
    y: 14.5 - 11 - 1 + 0.7,
  }, {
    id: 99,
    x: 16.2,
    y: 14.5 - 11 - 1.8 + 0.7,
  },
  // Austria 1785-1789
  {
    id: 214,
    x: 11.5 + 2.9,
    y: 14.5 - 17.6 + 0.7,
  }, {
    id: 91,
    x: 12.8 + 2.4,
    y: 14.5 - 16.9 + 0.7,
  }, {
    id: 183,
    x: 13.7 + 2.3,
    y: 14.5 - 16.7 + 0.7,
  }, {
    id: 24,
    x: 14.4 + 2.5,
    y: 14.5 - 15.3 + 0.7,
  }, {
    id: 134,
    x: 15.1 + 2.5,
    y: 14.5 - 14.3 + 0.7,
  }, {
    id: 140,
    x: 15.8 + 2.5,
    y: 14.5 - 13.4 + 0.7,
  }, {
    id: 212,
    x: 16.5 + 2.4,
    y: 14.5 - 12.5 + 0.7,
  }, {
    id: 25,
    x: 17.2 + 2.3,
    y: 14.5 - 11.6 + 0.7,
  }, {
    id: 58,
    x: 17.6 + 2.3,
    y: 14.5 - 10.6 + 0.7,
  }, {
    id: 151,
    x: 18 + 2.3,
    y: 4.9 + 0.7,
  },
  // Austria 1790-1794
  {
    id: 34,
    x: 18.5,
    y: 14.5 - 15.1 + 0.7,
  }, {
    id: 109,
    x: 19.2,
    y: 14.5 - 14.1 + 0.7,
  },
  // Austria 1795-1799
  {
    id: 179,
    x: 19.6,
    y: 14.5 - 11 - 4.1 + 0.7,
  },
  // Austria 1800-1804
  {
    id: 30,
    x: 20.5,
    y: 14.5 - 11 - 4.8 + 0.7,
  },
  // Russia
  // Russia 1775-1779
  {
    id: 194,
    x: 18.3,
    y: 33.3 + 0.7,
  }, {
    id: 195,
    x: 17.9,
    y: 34.2 + 0.7,
  }, {
    id: 0,
    x: 17.4,
    y: 35.1 + 0.7,
  }, {
    id: 85,
    x: 16.8,
    y: 36.0 + 0.7,
  }, {
    id: 89,
    x: 16.3,
    y: 36.9 + 0.7,
  }, {
    id: 96,
    x: 15.6,
    y: 37.8 + 0.7,
  },
  // Russia 1780-1784
  {
    id: 6,
    x: 18.5,
    y: 35.1 + 0.7,
  }, {
    id: 117,
    x: 18.0,
    y: 35.5 + 0.7,
  }, {
    id: 118,
    x: 17.4,
    y: 36.9 + 0.7,
  },
  // Netherlands
  // Netherlands 1790-1794
  {
    id: 52,
    x: 9.2,
    y: 46.9 + 0.7,
  },
  // Malta
  // Malta 1800-1804
  {
    id: 66,
    x: 21.7,
    y: 38.4 + 0.7,
  },
  // France
  // France 1775-1779
  {
    id: 146,
    x: 7.8,
    y: -5.1 + 0.7,
  }, {
    id: 166,
    x: 8.8,
    y: -4.6 + 0.7,
  }, {
    id: 106,
    x: 9.7,
    y: -4.0 + 0.7,
  },
  // France 1780-1784
  {
    id: 90,
    x: 9.5,
    y: -5.5 + 0.7,
  },
  // France 1785-1789
  {
    id: 23,
    x: 9.1,
    y: -6.8 + 0.7,
  }, {
    id: 22,
    x: 10.0,
    y: -6.8 + 0.7,
  }, {
    id: 132,
    x: 10.9,
    y: -5.7 + 0.7,
  },
  // France 1800-1804
  {
    id: 114,
    x: 11.1,
    y: -9.2 + 0.7,
  }, {
    id: 20,
    x: 12,
    y: -9.2 + 0.7,
  },
  // Poland
  // Poland 1810-1814
  {
    id: 38,
    x: 18.9,
    y: 45.4 + 0.7,
  }, {
    id: 39,
    x: 17.7,
    y: 46.4 + 0.7,
  },
  // Poland 1820-1824
  {
    id: 40,
    x: 20.0,
    y: 46.5 + 0.7,
  }, {
    id: 41,
    x: 18.8,
    y: 48.0 + 0.7,
  },
  // Poland 1825-1829
  {
    id: 42,
    x: 20.0,
    y: 47.8 + 0.7,
  },
  // Poland 1830-1834
  {
    id: 43,
    x: 20.6,
    y: 50.0,
  },
  // Czech Republic
  // Czech Republic 1775-1779
  {
    id: 105,
    x: 13.6,
    y: 40.0 + 0.7,
  },
  // Czech Republic 1785-1789
  {
    id: 51,
    x: 15.4,
    y: 41.3 + 0.7,
  }, {
    id: 188,
    x: 14.6,
    y: 42.1 + 0.7,
  },
  // Czech Republic 1790-1794
  {
    id: 157,
    x: 15.6,
    y: 42.3 + 0.7,
  },
  // England
  // England 1775-1779
  {
    id: 164,
    x: 9.6,
    y: 43.0 + 0.7,
  },
  // England 1790-1794
  {
    id: 172,
    x: 11.3,
    y: 45.5 + 0.7,
  },
  // England 1795-1799
  {
    id: 177,
    x: 11.9,
    y: 46.5 + 0.7,
  }
];
